import React from 'react';
export const CookiePolicy = () => {
  return <div className="pt-20" data-id="element-2820" data-mp="28j1xhs0zska8">
      <section className="py-16 bg-secondary/5" data-id="element-2821" data-mp="2ot2kowsc6ypi">
        <div className="container mx-auto px-4" data-id="element-2822" data-mp="2ouckprir2gys">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2823" data-mp="33qbst25v0h3x">
            Cookie Policy
          </h1>
          <p className="text-center text-secondary" data-id="element-2824" data-mp="2yqpbagj00epb">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-2825" data-mp="3cq8cepde6ps4">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-2826" data-mp="3cp6z0e8wlr78">
          <div className="prose prose-lg max-w-none" data-id="element-2827" data-mp="37sou9edkpsuw">
            <p data-id="element-2828" data-mp="37q2p1le5npfu">
              The Networking Salon ("we," "our," or "us") uses cookies and
              similar technologies on our website to improve your browsing
              experience, analyze traffic, and provide relevant content. This
              Cookie Policy explains what cookies are, how we use them, and your
              choices.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2829" data-mp="3rh7cfc05w603">
              1. What Are Cookies?
            </h2>
            <p data-id="element-2830" data-mp="1xx8hmzqd3uhb">
              Cookies are small text files stored on your device when you visit
              a website. They help websites recognize your device, remember
              preferences, and improve functionality.
            </p>
            <p data-id="element-2831" data-mp="2bv5fdzgjy6xk">Cookies may be:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2832" data-mp="2bwggtsmiz2li">
              <li data-id="element-2833" data-mp="2gui1ghzln9z3">
                <strong data-id="element-2834" data-mp="2gv1jdyp91yd4">Session Cookies:</strong> Temporary, deleted when you
                close your browser.
              </li>
              <li data-id="element-2835" data-mp="2kusgsl9a7cqm">
                <strong data-id="element-2836" data-mp="2kuaf393uo6bb">Persistent Cookies:</strong> Stay on your device until
                deleted or they expire.
              </li>
              <li data-id="element-2837" data-mp="2uln65yhtqsga">
                <strong data-id="element-2838" data-mp="2um6bmfqafodf">First-Party Cookies:</strong> Placed by our website.
              </li>
              <li data-id="element-2839" data-mp="2zlj71ov863rm">
                <strong data-id="element-2840" data-mp="2zm2kas9xk3zb">Third-Party Cookies:</strong> Placed by external
                services (e.g., Google Analytics, social media).
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2841" data-mp="2evfcjhu2owry">
              2. How We Use Cookies
            </h2>
            <p data-id="element-2842" data-mp="29xna3tvsxs9i">We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2843" data-mp="29yoxmxu08784">
              <li data-id="element-2844" data-mp="2oma1wv2m8chm">
                <strong data-id="element-2845" data-mp="2omtfy0p5agqd">Essential:</strong> Ensure our website functions
                properly (e.g., navigation, forms).
              </li>
              <li data-id="element-2846" data-mp="2jt73a8izecuk">
                <strong data-id="element-2847" data-mp="2xm6h86347z00">Analytics:</strong> Understand how visitors use our site
                to improve performance (e.g., Google Analytics).
              </li>
              <li data-id="element-2848" data-mp="2sn3q7pjyztb1">
                <strong data-id="element-2849" data-mp="2spprx8k6jelc">Preferences:</strong> Remember your settings (e.g.,
                language, event selections).
              </li>
              <li data-id="element-2850" data-mp="32l9pdzee6lc7">
                <strong data-id="element-2851" data-mp="32muidkl25w7y">Marketing:</strong> Deliver relevant promotions and
                measure the effectiveness of campaigns.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2852" data-mp="1881opr3qjfin">
              3. Third-Party Cookies
            </h2>
            <p data-id="element-2853" data-mp="3julpfm6jrlwf">We may use trusted third-party services, including:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2854" data-mp="3otyk2t3ntx9k">
              <li data-id="element-2855" data-mp="3otf43hxkliy6">Google Analytics for insights on website usage.</li>
              <li data-id="element-2856" data-mp="3a5u07lsvffp7">
                Social Media Plugins (e.g., LinkedIn, Instagram) for sharing and
                engagement.
              </li>
            </ul>
            <p data-id="element-2857" data-mp="3f1sn14yjwpni">
              These providers may set cookies according to their own privacy
              policies.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2858" data-mp="3567nrekva3hg">4. Your Choices</h2>
            <p data-id="element-2859" data-mp="2r6g34uzuhouh">You can manage or disable cookies by:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2860" data-mp="2r7r7ox1470mn">
              <li data-id="element-2861" data-mp="2w4rbt2eeltb4">
                Adjusting your browser settings to block or delete cookies.
              </li>
              <li data-id="element-2862" data-mp="pejq1gy146xl">
                Opting out of analytics/advertising cookies where applicable.
              </li>
            </ul>
            <p data-id="element-2863" data-mp="ud4uxto87esd">
              Please note: disabling cookies may affect website functionality.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2864" data-mp="2qeyg92uf4b84">
              5. Updates to This Policy
            </h2>
            <p data-id="element-2865" data-mp="2lg4yuzc0g02o">
              We may update this Cookie Policy to reflect changes in technology,
              legal requirements, or our practices. Updates will be posted on
              this page with a new "last updated" date.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2866" data-mp="27j8b56r6uyq0">6. Contact Us</h2>
            <p data-id="element-2867" data-mp="22qygxej1jchx">For questions about our use of cookies, please contact us:</p>
            <p data-id="element-2868" data-mp="1xsddz7cemeps">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2869" data-mp="1xtezk5r1qjlr">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};